<template>
  <th
    class="th-ex"
    style="border-bottom: 1px solid #3389ff; border-top: 2px solid #3389ff"
  >
    <slot></slot>
    <div
      class="info-icon"
      v-if="tip"
      @mouseover="showMsg = true"
      @mouseout="showMsg = false"
    >
      <i>!</i>
    </div>
    <div class="info-msg" v-if="showMsg && tip">
      <p v-html="tip"></p>
    </div>
  </th>
</template>

<script>
export default {
  props: {
    tip: String,
  },
  data() {
    return {
      showMsg: false,
    };
  },
};
</script>

<style lang="stylus" scoped>
.th-ex
    background-clip:padding-box;
    position relative;
    height: 37px;
    font-size: 14px;
    line-height: 37px;
    background-color: #f8f9f8;
    border-top:2px solid #3389ff;
    border-left 1px solid #ddd;
    border-right  1px solid #ddd;
    border-bottom: 1px solid #3389ff;
    font-weight: bold;
    color #666;
.info-icon
    position absolute
    right 9px
    top 12px
    height 14px
    width 15px
    background-color rgb(255, 108, 0)
    border-radius 50%
    display flex
    justify-content center
    align-items center
    vertical-align baseline
    color #fff
    cursor pointer

.info-icon i
    font-size 100%
    font-style normal
    font-weight 500

.info-msg
    position absolute
    color #fff
    background-color #000
    border-radius 5px
    width 290px
    bottom 40px
    left:-90px;
    line-height 20px
    padding 5px
    z-index 1000
    font-size 12px
</style>
